module.exports = __webpack_public_path__ + "img/page.b753f222.png";